import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SessionsList = ({ children, placeholder, hasDurationCol, className }) => {
  const { t } = useTranslation('components');
  const cn = useClassNames(
    () => ['lg:flex', 'lg:flex-col', 'lg:shadow-lg', 'lg:border', className],
    [className],
  );

  return (
    <div data-component="SessionsList" className={cn}>
      <div className="hidden lg:flex py-4 px-6 flex-1 uppercase font-semibold text-slate-500 text-sm border-b">
        <div className="w-24 lg:px-4" />
        <div className="w-2/12 lg:px-4">{t('Sessions.SessionsList.appointment')}</div>
        {hasDurationCol && (
          <div className="w-2/12 lg:px-4">{t('Sessions.SessionsList.duration')}</div>
        )}
        <div className="w-2/12 lg:px-4">{t('Sessions.SessionsList.details')}</div>
      </div>
      {children ? (
        <ul>{children}</ul>
      ) : (
        <div className="text-center py-16 text-slate-500">{placeholder}</div>
      )}
    </div>
  );
};

SessionsList.propTypes = {
  children: PropTypes.node,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  hasDurationCol: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default SessionsList;
